var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',_vm._b({staticClass:"select-none",class:[_vm.iconName],style:(_vm.iconStyles)},'i',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.iconPack === 'material-icons' ? _vm.icon : ''))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }